var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        "max-width": "1280",
        scrollable: "",
        "content-class": "promo-panoramica-dialog",
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        { staticClass: "promo-panoramica-card" },
        [
          _c(
            "v-img",
            {
              staticClass: "promo-panoramica-image",
              attrs: {
                "aspect-ratio": "1.7777778",
                src: _vm.promoPanoramicaImage,
              },
            },
            [
              _c("div", { staticClass: "promo-panoramica-title-overlay" }, [
                _c(
                  "div",
                  { staticClass: "promo-panoramica-title font-hemi-head" },
                  [_vm._v('\n          Nuova visuale "Panoramica"\n        ')]
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "promo-panoramica-content white--text pa-4" },
            [
              _c(
                "v-alert",
                {
                  staticClass: "promo-panoramica-alert",
                  attrs: { dense: "", text: "", color: "info" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "font-hemi-head promo-panoramica-subtitle" },
                    [
                      _vm._v(
                        "Panoramica di tutte le rose, svincolati, pianificazione e chat in una unica visuale personalizzabile."
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c(
                        "v-icon",
                        {
                          staticClass: "mr-1 info--text",
                          attrs: { small: "" },
                        },
                        [_vm._v("info")]
                      ),
                      _vm._v("Per attivarla/disattivarla premi  "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "white--text mx-2",
                          attrs: {
                            color: "navy lighten-2",
                            fab: "",
                            "x-small": "",
                          },
                          on: { click: _vm.tryNow },
                        },
                        [_c("v-icon", [_vm._v("view_module")])],
                        1
                      ),
                      _vm._v(" nella toolbar in alto a destra."),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            { staticClass: "promo-panoramica-actions d-flex flex-column" },
            [
              _c(
                "div",
                { staticClass: "promo-panoramica-actions-buttons" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "font-hemi-head px-8",
                      attrs: { color: "secondary", rounded: "", large: "" },
                      on: { click: _vm.tryNow },
                    },
                    [_vm._v("\n          Provala subito\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "font-hemi-head px-8",
                      attrs: {
                        color: "secondary",
                        outlined: "",
                        rounded: "",
                        large: "",
                      },
                      on: { click: _vm.dismiss },
                    },
                    [_vm._v("\n          Chiudi\n        ")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-checkbox", {
                staticClass: "promo-panoramica-checkbox",
                attrs: {
                  dark: "",
                  dense: "",
                  "hide-details": "",
                  label: "Non mostrare più",
                },
                model: {
                  value: _vm.dontShowAgain,
                  callback: function ($$v) {
                    _vm.dontShowAgain = $$v
                  },
                  expression: "dontShowAgain",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }